module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan01_american-village-395e857637ed464ae2dbc8713ff5e863.jpg";